<template>
  <aside class="bnr_area">
    <div class="bnr_area__inner">
      <ul>
        <li class="icon_dealer">
          <a class="" href="https://www.renault.jp/support/dealer_map.html" target="_blank"
            >ディーラー検索</a
          >
        </li>
        <li class="icon_counseling" v-if="counseling">
          <a :href="url3" target="_blank">購入相談</a>
        </li>
        <li class="icon_ride" v-if="testdrive_id">
          <a :href="url" target="_blank">試乗申し込み</a>
        </li>
        <li class="icon_catalog" v-if="catalog_id">
          <a :href="url2" target="_blank">カタログ請求</a>
        </li>
      </ul>
    </div>
  </aside>
</template>

<script>
import { computed, provide, reactive, ref, inject } from "vue";

export default {
  name: "App",
  props: ["td_id", "car_id", "p_url"],
  setup(props) {
    let number = ref(props.td_id);
    let car_id = ref(props.car_id);
    let p_url  = ref(props.p_url);
    let url = "https://www.renault.jp/support/test_drive.php";
    let url2 = "https://www.renault.jp/support/catalog.php";
    let url3 = "https://www.renault.jp/support/purchase.php";
    let testdrive_id = true;
    if (number.value === "") {
      testdrive_id = false;
    };
    let catalog_id = true;
    if (car_id.value === "") {
      catalog_id = false;
    };
    if (number.value !== undefined) {
      url = "https://www.renault.jp/support/test_drive.php?td_id=" + number.value;
    };
    if (car_id.value !== undefined) {
      url2 = "https://www.renault.jp/support/catalog.php?carid=" + car_id.value;
    };
//  2025/07/22 カタログ請求 削除
    catalog_id = false;
    let counseling = false;
//  購入相談の表示条件を記入する
//    if (!testdrive_id || !catalog_id) {
//      counseling = true;
//    }
    if (p_url.value !== "" && p_url.value !== undefined) {
          url3 = p_url.value;
    }

    return {
      url,
      url2,
      url3,
      catalog_id,
      testdrive_id,
      counseling
    };
  },
};
</script>
